import { Invoice } from "../../types/InvoiceTypes";
import { AccountType } from "../../types/UserTypes";

type CheckResponse = {
  valid: boolean;
  message?: string;
};

export const checkIssuerDetails = (
  data: Invoice | undefined
): CheckResponse => {
  if (!data || !data.issuer_data) {
    return {
      valid: false,
      message: "Add missing data",
    };
  }

  const { issuer_data } = data;

  if (!issuer_data.country) {
    return {
      valid: false,
      message: "Add missing country",
    };
  }

  if (
    issuer_data.account_type === AccountType.CONTRACTOR &&
    !issuer_data.postal_code
  ) {
    return {
      valid: false,
      message: "Add missing postal code",
    };
  }

  if (
    issuer_data.account_type === AccountType.CONTRACTOR &&
    !issuer_data.city
  ) {
    return {
      valid: false,
      message: "Add missing city",
    };
  }

  if (
    issuer_data.account_type === AccountType.BUSINESS &&
    !issuer_data.reg_number
  ) {
    return {
      valid: false,
      message: "Add missing registration number",
    };
  }

  if (
    issuer_data.account_type === AccountType.BUSINESS &&
    !issuer_data.tax_id
  ) {
    return {
      valid: false,
      message: "Add missing tax id",
    };
  }

  return {
    valid: true,
  };
};

export const checkPayerDetails = (data: Invoice | undefined) => {
  if (!data || !data.payer_data) {
    return {
      valid: false,
      message: "Add missing data",
    };
  }

  const { payer_data } = data;

  if (!payer_data.name) {
    return {
      valid: false,
      message: "Add missing name",
    };
  }

  if (!payer_data.country) {
    return {
      valid: false,
      message: "Add missing country",
    };
  }

  if (
    payer_data.account_type === AccountType.CONTRACTOR &&
    !payer_data.postal_code
  ) {
    return {
      valid: false,
      message: "Add missing postal code",
    };
  }

  if (payer_data.account_type === AccountType.CONTRACTOR && !payer_data.city) {
    return {
      valid: false,
      message: "Add missing city",
    };
  }

  if (!payer_data.reg_number) {
    return {
      valid: false,
      message: "Add missing registration number",
    };
  }

  if (!payer_data.tax_id) {
    return {
      valid: false,
      message: "Add missing tax id",
    };
  }

  return {
    valid: true,
  };
};

export const checkJobDetails = (data: Invoice | undefined) => {
  if (!data || !data.items || data.items.length === 0) {
    return false;
  }

  return checkJobDescriptions(data) && checkJobAmounts(data);
};

export const checkJobDescriptions = (data: Invoice | undefined) => {
  if (!data || !data.items || data.items.length === 0) {
    return false;
  }

  return data.items?.every(({ description }) => !!description);
};

export const checkJobAmounts = (data: Invoice | undefined) => {
  if (!data || !data.items || data.items.length === 0) {
    return false;
  }

  return data.items?.every(({ rate }) => !!rate && Math.round(rate) > 0);
};

export const checkWallet = (data: Invoice | undefined) => {
  if (!data) {
    return false;
  }

  const { outgoing_payment_details } = data;
  return !!(outgoing_payment_details && outgoing_payment_details.chain);
};
